import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Mobile / smartphone — appareil duotone */
export const MobileIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Écran menthe */}
      <rect x="7" y="5" width="10" height="13" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Boîtier */}
      <rect x="6" y="2.5" width="12" height="19" rx="2.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Écran contour */}
      <rect x="7" y="5" width="10" height="13" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Bouton home */}
      <circle cx="12" cy="20" r="0.85" fill="var(--equiply-icon-fg)" />
      {/* Encoche speaker */}
      <path d="M10.5 4h3" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
MobileIcon.displayName = "MobileIcon";
